export default "__VITE_ASSET__DOyCpBLu__"